import React, { useContext } from 'react';
import { AppContext } from '../../../main/context/Provider';

const PageTransition = () => {
    const { isSkinSmart } = useContext(AppContext);

    return (
        <div
            className='d-flex justify-content-center align-items-center'
            style={{
                width: '80%',
                height: '100vh',
                textAlign: 'center',
                margin: 'auto',
            }}
        >
            <img
                src={`/assets/images/transitions/${
                    isSkinSmart ? 'transition_smart' : 'transition_siesa'
                }.gif`}
                alt='Transition_SmartAccess'
                style={{
                    width: '15%',
                    height: '25%',
                    textAlign: 'center',
                }}
            />
        </div>
    );
};
export default PageTransition;
